@if (generating()) {
  <div class="ai-loading" [attr.aria-label]="'QUESTIONS.GENERATING' | translate">
    @if (mode() !== 'question') {
      <nr-skeleton [type]="'title'"></nr-skeleton>
    }

    @for (questionIndex of loadingQuestionIndexes(); track questionIndex) {
      <div class="ai-loading-card">
        <nr-skeleton></nr-skeleton>
        <nr-skeleton [type]="'medium'"></nr-skeleton>
        @if (loadingOpenEnded()) {
          <nr-skeleton></nr-skeleton>
          <nr-skeleton [type]="'medium'"></nr-skeleton>
        } @else {
          @for (answerIndex of loadingAnswerIndexes(); track answerIndex) {
            <nr-skeleton></nr-skeleton>
          }
        }
      </div>
    }

    <nr-skeleton [type]="'title'"></nr-skeleton>
    <div class="ai-loading-settings">
      @for (row of loadingSettingsRowIndexes(); track row) {
        <div class="ai-loading-settings-row">
          <span class="ai-loading-settings-checkbox">
            <nr-skeleton></nr-skeleton>
          </span>
          <nr-skeleton [type]="'medium'"></nr-skeleton>
        </div>
      }
    </div>
  </div>
} @else {
  @if (mode() === 'question') {
    <div class="answer-type-row">
      <odl-radio-group [value]="answerType()" (odl-input)="onAnswerTypeChange($event)">
        <span slot="label">{{ 'QUESTIONS.ANSWER_TYPE' | translate }}</span>
        <div class="answer-type-option">
          <input
            type="radio"
            name="ai-answer-type"
            id="ai-answer-type-open-ended"
            value="openEnded"
          />
          <label for="ai-answer-type-open-ended">
            {{ 'QUESTIONS.OPEN_ENDED_ANSWER' | translate }}
          </label>
        </div>
        <div class="answer-type-option">
          <input
            type="radio"
            name="ai-answer-type"
            id="ai-answer-type-multiple-choice"
            value="multipleChoice"
          />
          <label for="ai-answer-type-multiple-choice">
            {{ 'QUESTIONS.MULTIPLE_CHOICE_ANSWER' | translate }}
          </label>
        </div>
      </odl-radio-group>
    </div>
  }

  @if (mode() === 'question') {
    @if (answerType() === 'multipleChoice') {
      <div class="answer-count-card">
        <span class="stepper-label">{{ 'QUESTIONS.NUMBER_OF_ANSWERS' | translate }}</span>
        <div class="stepper">
          <odl-button
            variant="text"
            [description]="'QUESTIONS.DECREASE' | translate"
            [disabled]="numberOfAnswers() <= MIN_AI_ANSWERS"
            (click)="decrementNumberOfAnswers()"
          >
            <odl-icon name="remove_circle" slot="only-icon"></odl-icon>
          </odl-button>
          <span class="stepper-value">{{ numberOfAnswers() }}</span>
          <odl-button
            variant="text"
            [description]="'QUESTIONS.INCREASE' | translate"
            [disabled]="numberOfAnswers() >= MAX_AI_ANSWERS"
            (click)="incrementNumberOfAnswers()"
          >
            <odl-icon name="add_circle" slot="only-icon"></odl-icon>
          </odl-button>
        </div>
      </div>
    }
  } @else {
    <div class="stepper-fields">
      <div class="stepper-field" data-testid="questions-stepper">
        <span class="stepper-label">{{ 'QUESTIONS.NUMBER_OF_QUESTIONS' | translate }}</span>
        <div class="stepper">
          <odl-button
            variant="text"
            [description]="'QUESTIONS.DECREASE' | translate"
            [disabled]="questionsNumber() <= MIN_AI_QUESTIONS"
            (click)="decrementQuestionsNumber()"
          >
            <odl-icon name="remove_circle" slot="only-icon"></odl-icon>
          </odl-button>
          <span class="stepper-value">{{ questionsNumber() }}</span>
          <odl-button
            variant="text"
            [description]="'QUESTIONS.INCREASE' | translate"
            [disabled]="questionsNumber() >= MAX_AI_QUESTIONS"
            (click)="incrementQuestionsNumber()"
          >
            <odl-icon name="add_circle" slot="only-icon"></odl-icon>
          </odl-button>
        </div>
      </div>

      <div class="stepper-field">
        <span class="stepper-label">{{ 'QUESTIONS.NUMBER_OF_ANSWERS' | translate }}</span>
        <div class="stepper">
          <odl-button
            variant="text"
            [description]="'QUESTIONS.DECREASE' | translate"
            [disabled]="numberOfAnswers() <= MIN_AI_ANSWERS"
            (click)="decrementNumberOfAnswers()"
          >
            <odl-icon name="remove_circle" slot="only-icon"></odl-icon>
          </odl-button>
          <span class="stepper-value">{{ numberOfAnswers() }}</span>
          <odl-button
            variant="text"
            [description]="'QUESTIONS.INCREASE' | translate"
            [disabled]="numberOfAnswers() >= MAX_AI_ANSWERS"
            (click)="incrementNumberOfAnswers()"
          >
            <odl-icon name="add_circle" slot="only-icon"></odl-icon>
          </odl-button>
        </div>
      </div>
    </div>
  }

  <odl-divider></odl-divider>

  @if (!seedText() || !hasContent()) {
    @if (!seedText()) {
      <div class="ai-source">
        <odl-radio-group [value]="source()" (odl-input)="onSourceChange($event)">
          <span slot="label">{{ 'QUESTIONS.GENERATE_FROM' | translate }}</span>
          <div class="ai-source-row">
            <input type="radio" name="ai-source" id="ai-source-visible" value="visible" />
            <label for="ai-source-visible">{{ 'QUESTIONS.VISIBLE_TEXT' | translate }}</label>
          </div>
          <div class="ai-source-row">
            <input type="radio" name="ai-source" id="ai-source-chapter" value="chapter" />
            <label for="ai-source-chapter">{{ 'QUESTIONS.ALL_CHAPTER' | translate }}</label>
          </div>
        </odl-radio-group>
      </div>
    }

    @if (!hasContent()) {
      <odl-callout variant="warning">{{ 'QUESTIONS.NO_CONTENT_WARNING' | translate }}</odl-callout>
    }

    <odl-divider></odl-divider>
  }

  @if (competencies().length) {
    <nr-competency-picker
      [competencies]="competencies()"
      [(selected)]="selectedCompetencies"
    ></nr-competency-picker>

    <odl-divider></odl-divider>
  }

  <div class="ai-actions">
    <odl-button variant="secondary" (click)="skip.emit()">
      {{ 'CANCEL' | translate }}
    </odl-button>
    <odl-button variant="primary" [disabled]="!hasContent()" (click)="onGenerateClick()">
      <odl-icon name="ai" slot="start"></odl-icon>
      {{ 'QUESTIONS.GENERATE' | translate }}
    </odl-button>
  </div>
}
